<template>
  <div :class="containerClass">
    <div class="notification-wrapper__icon">
      <i class="icon" :class="iconClass"></i>
    </div>
    <div class="notification-wrapper__content">
      <a class="title">
        {{config.item.title}}
      </a>
      <a class="close" @click="config.close">
        <i class="notifications--icon"><icon-close /></i>
      </a>
      <div>
        <h1 class="title">{{ config.item.text }}</h1>

        <h4 class="description" v-if="description">{{ description }}</h4>

        <button class="button button--default-ghost" v-if="firstAction" @click="firstAction.action">{{ firstAction.text }}</button>
        <button class="button button--default-ghost" v-if="secondAction" @click="secondAction.action">{{ secondAction.text }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import IconClose from '@/shared/components/icons/close';

export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
    firstAction: {
      type: Object,
      required: false,
      default: null,
    },
    secondAction: {
      type: Object,
      required: false,
      default: null,
    },
    description: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    containerClass() {
      if (this.type === 'warn') {
        return 'warning';
      }

      return this.type;
    },
    iconClass() {
      let replace = this.containerClass;

      if (this.type === 'info') {
        replace = 'warning';
      }

      return `c-icon--${replace}`;
    },
    type() {
      return this.config.item.type;
    },
    firstActionText() {
      if (this.firstAction && this.firstAction.text) {
        return this.firstAction.text;
      }

      return 'ok';
    },
    secondActionText() {
      if (this.secondAction && this.secondAction.text) {
        return this.secondAction.text;
      }

      return 'cancel';
    },
  },
  components: {
    IconClose,
  },
};
</script>



// WEBPACK FOOTER //
// NotificationBody.vue?d1cd49fa